export const ROUTES = {
  location: '/location',
  what: '/what',
};